import React from "react";
import { imgArr } from "../../assets/images";
import "./index.scss";
import { Link, useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();

  return (
    <footer className="footer wapper">
      <div className="footer-top">
        <div className="logo-section">
          <div
            onClick={() => {
              navigate("/");
            }}
          >
            <img src={imgArr.logoWhite} alt="logo" className="footer-logo" />
          </div>
          <div className="social-icons">
            <a
              href="https://www.instagram.com/circuit.app"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={imgArr.instaIcon}
                alt="Instagram"
                width={30}
                height={30}
              />
            </a>
            <a
              href="https://tiktok.com/Circuit.app"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={imgArr.tiktokIcon}
                alt="TikTok"
                width={30}
                height={30}
              />
            </a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>
          Copyright © 2025 <strong>Circuit</strong> All Rights Reserved |
          <Link to="/privacy-policy">Privacy Policy</Link> |
          <Link to="/terms-condition">Terms and conditions</Link>.
        </p>
        <div className="developer-info">
          <img src={imgArr.iqlanceLogo} alt="iQlance Logo" />
          <p>
            DESIGNED AND DEVELOPED BY:
            <span> iQlance Solution Pvt Ltd</span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
